import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { GetUserContactsStatus } from '../api/api';
import { isNativeApp } from '../utils/deviceIdentity';
import { lastSyncAt, syncPhoneBook } from '../utils/contactSync';

// Keeps a signed-in user's synced phone book up to date — APK only, renders nothing.
// When the app starts or comes back to the front, and the last sync is older
// than 12 hours, it quietly uploads ONLY new / changed contacts
// (utils/contactSync). It runs only for a user who agreed to the disclosure
// (consent date on the server), never shows the permission dialog, and never
// while a Super Admin views as another user.
const EVERY_MS = 12 * 60 * 60 * 1000;

export default function ContactAutoSync() {
  const { user, isViewingAs } = useAuth();
  const userId = user?.UserId;

  useEffect(() => {
    if (!isNativeApp() || !userId || isViewingAs) return undefined;
    let running = false;
    let cancelled = false;
    const run = async () => {
      if (running || cancelled || Date.now() - lastSyncAt(userId) < EVERY_MS) return;
      running = true;
      try {
        const st = await GetUserContactsStatus({ UserId: userId });
        if (st && st.consentDate && !cancelled) await syncPhoneBook(userId, { prompt: false });
      } catch { /* offline / refused: try again next time */ } finally {
        running = false;
      }
    };
    run();
    let handle = null;
    import('@capacitor/app').then(({ App }) => App.addListener('appStateChange', (s) => { if (s.isActive) run(); }))
      .then(h => { if (cancelled) h && h.remove(); else handle = h; })
      .catch(() => {});
    return () => { cancelled = true; if (handle) handle.remove(); };
  }, [userId, isViewingAs]);

  return null;
}
